// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.maintenance.RentalManagerMaintenanceConfigWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerMaintenanceConfigsDto } from '../..';

export const RentalManagerMaintenanceConfigWebApiHandler_config_Path = '/api/web/v1/maintenance/config';

/**
 * Get maintenance configs
 */
export const RentalManagerMaintenanceConfigWebApiHandler_config = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerMaintenanceConfigsDto>(
    {
      endpoint: RentalManagerMaintenanceConfigWebApiHandler_config_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
